export const LogoMark = ({ size = 38 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        role="img"
        aria-label="Logotipo de Puertalia"
        data-testid="logo-mark"
    >
        <rect width="48" height="48" rx="11" fill="#c2410c" />
        <path d="M24 9.5 38.5 22h-4.2v14.5H13.7V22H9.5Z" fill="#ffffff" />
        <rect x="21.2" y="27" width="5.6" height="9.5" rx="1" fill="#c2410c" />
        <circle cx="25.4" cy="31.8" r="0.7" fill="#ffffff" />
    </svg>
);

export const Logo = ({ light = false }) => (
    <span className="flex items-center gap-2.5" data-testid="logo">
        <LogoMark />
        <span
            className={`font-sans text-xl font-extrabold tracking-tight ${
                light ? "text-white" : "text-brand-navy dark:text-white"
            }`}
        >
            Puertalia<span className="text-brand-orange">.</span>
        </span>
    </span>
);
